import clsx from "clsx";
import * as React from "react";

const SharedIcon = React.forwardRef(
  ({ className, children, iconName, ...props }, ref) => (
    <svg ref={ref} className={clsx("icon", className)} {...props}>
      <use href={iconName} xlinkHref={iconName}></use>
    </svg>
  )
);

export { SharedIcon };
